export enum SchedulerDataType {
  CONSULTATION = 'CONSULTATION',
  ORDER = 'ORDER',
  SCHEDULE = 'SCHEDULE',
  UNAVAILABILITY = 'UNAVAILABILITY',
}
